import type { Device } from '@studio/models/device';
import type { Room } from '@studio/models/room';
import QuickLRU from 'quick-lru';

/** @internal */
export const locationCache = new QuickLRU<Device['id'], Room['id']>({
  maxSize: 100
});
